import axios from './axiosInstances/axiosInstance';

export const updateGroupOrder = (groupOrderId, deadline, note) => {
  const body = {
    deadline: deadline,
    note: note,
  };
  return axios.put(`/baskets/grouporders/${groupOrderId}`, body);
};
